'use strict';

module.exports = inlineHeaders;

var encode = require('querystring-es3/encode');

function inlineHeaders(url, headers) {
  if (/\?/.test(url)) {
    url += '&';
  } else {
    url += '?';
  }

  return url + encode(headers);
}



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/inline-headers.js
// module id = ./node_modules/algoliasearch/src/browser/inline-headers.js
// module chunks = 0 1